import { useCollaborationSession } from 'copilot-toolkit/hooks/useCollaborationSession';
import { useCallback } from 'react';
const useCollabGenerateTriggers = ({
  sessionId
}) => {
  const handleCopilotAction = useCallback(() => {
    // TODO: Implement the logic to handle preview and save triggers
  }, []);
  const {
    sendActionFromAppToCopilot,
    isCopilotReady
  } = useCollaborationSession({
    onCopilotAction: handleCopilotAction,
    onGetCurrentSessionContext: () => {},
    sessionId,
    appName: 'workflows',
    plugin: 'WorkflowsGenerateTriggersPlugin'
  });
  return {
    isCopilotReady,
    sendActionFromAppToCopilot
  };
};
export default useCollabGenerateTriggers;